import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import { useCallback, useMemo } from 'react'
import { AddOrganizationPrompt } from '../components/AddOrganizationPrompt'
import { Organization, OrganizationFormData } from 'organization/types'
import { mapOrgToPayload } from 'organization/helpers'
import useCreateOrUpdateOrganization from './useCreateOrUpdateOrganization'
import { mapEventGeofencingToGeofencing } from 'utils/event'
import { DEFAULT_GEOFENCING } from 'civic-champs-shared/constants/GEO_DATA'

export const useShowOrganizationAdd = (onSuccess?: (result: Organization) => void) => {
  const showPrompt = useShowPrompt(AddOrganizationPrompt)
  const createOrUpdateOrganization = useCreateOrUpdateOrganization()
  const createNotification = useCreateApiNotification()
  let org: OrganizationFormData = {
    location: {
      type: DEFAULT_GEOFENCING.location.type,
      coordinates: [DEFAULT_GEOFENCING.location.coordinates.lng,DEFAULT_GEOFENCING.location.coordinates.lat],
    },
    limitFutureEventVisibility: false,
    sandboxModeEnabled: false,
    futureEventVisibilityDays: null,
  }
  const initialValue = useMemo<OrganizationFormData>(
    () => ({
      ...org,
      address: {
        ...org.address,
        geofencing: mapEventGeofencingToGeofencing({ ...org, radius: 0 }),
      },
      websiteEnabled: true,
    }),
    [org],
  )

  return useCallback(async () => {
    const organization = await showPrompt({ initialValue })
    const gps = organization.address?.geofencing?.location?.coordinates
    if (gps) {
      organization.address.gps = gps
    } else if (organization.location && organization.location.coordinates) {
      const [lng, lat] = organization.location?.coordinates
      organization.address.gps = { lat, lng }
    }
    const notification = createNotification(`Saving Organization`)
    try {
      const newOrganization = await createOrUpdateOrganization({
        ...mapOrgToPayload(organization),
        timeZone: (organization.timeZone as any).value,
      })
      onSuccess?.(newOrganization)
      notification.onSuccess('Organization saved successfully')
    } catch (e) {
      notification.onError('Failed to save organization', e)
    }
  }, [createNotification, createOrUpdateOrganization, initialValue, onSuccess, showPrompt])
}
